import AppBar from '@/components/app-bar/AppBar.vue'
import AppBarSpace from '@/components/app-bar/AppBarSpace.vue'

export default {
    name: 'MyContestHelp',
    components: {
        AppBar,
        AppBarSpace,
    }
}
